// 20MB raw → ~26MB after base64 encoding, fits within 25MB SMTP limit with margin.
export const MAX_TOTAL_ATTACHMENT_SIZE = 20 * 1024 * 1024

export const ALLOWED_ATTACHMENT_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/gif',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
]

// Type-confirm gate threshold for confirm dialog.
export const LARGE_SEND_THRESHOLD = 500
